// Story 10.2 — Skeleton del Bot Card. Mantiene el layout exacto para evitar CLS.
import { Card, CardContent, CardFooter, CardHeader } from '@/components/ui/card';

export function BotCardSkeleton(): React.ReactElement {
  return (
    <Card aria-busy="true" aria-label="Cargando bot">
      <CardHeader>
        <div className="flex items-center justify-between gap-2">
          <div className="h-5 w-32 animate-pulse rounded bg-muted" />
          <div className="h-5 w-16 animate-pulse rounded-full bg-muted" />
        </div>
        <div className="mt-1 h-3 w-40 animate-pulse rounded bg-muted/70" />
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-3 gap-2">
          {[0, 1, 2].map((i) => (
            <div key={i} className="h-16 animate-pulse rounded-md bg-muted/60" />
          ))}
        </div>
      </CardContent>
      <CardFooter>
        <div className="h-9 w-full animate-pulse rounded-md bg-muted" />
      </CardFooter>
    </Card>
  );
}
